import { render, staticRenderFns } from "./bonusBanner.vue?vue&type=template&id=4959032a&scoped=true"
import script from "./bonusBanner.vue?vue&type=script&lang=js"
export * from "./bonusBanner.vue?vue&type=script&lang=js"
import style0 from "./bonusBanner.vue?vue&type=style&index=0&id=4959032a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959032a",
  null
  
)

export default component.exports